import React from 'react';
import { Layout } from 'antd';

import { AccountContent } from 'toolkit/content/AccountContent';
import { AccountFooter } from 'toolkit/footer/AccountFooter';
import { AccountHeader } from 'toolkit/header/AccountHeader';

import './MainLayout.less';

type IMainLayoutProps = {
    children?: React.ReactNode
}

export function MainLayout(props: IMainLayoutProps) {
  return (
    <Layout className="main-layout">
      <AccountHeader />
      <AccountContent>
        <Layout className="main-layout__content">
          {props.children}
        </Layout>
      </AccountContent>
      <AccountFooter />
    </Layout>
  );
}
